import React from "react";
import { useTranslationContext } from "@providers/TranslationProvider";
import Divider from "@components/Divider";
import Button from "@components/Button";
import Card from "@components/Offers/Card";
import styles from "./OtherOffers.module.scss";
import cx from "classnames";
import _ from "lodash";
import { usePageContext } from "@providers/PageProvider";
import helper from "@utils/helper";
import { useRouteContext } from "@providers/RouteProvider";
const View = ({}: any) => {
  const { i18n } = useTranslationContext();
  const { otherOffers } = usePageContext();
  const { router } = useRouteContext();
  const offers = _.map(otherOffers, helper.formatOfferItem);
  return (
    <section data-scroll-section className={cx("inner", styles.section)}>
      <Divider light={true} label={i18n.t("Offer.otherOffer")} />

      <div className={styles.box}>
        {_.map(offers.slice(0, 2), (item: any, index: number) => {
          return <Card {...item} key={`card_${index}`} mode="light" />;
        })}
      </div>
      <Button
        onClick={() => {
          router.push("offers");
        }}
        className={styles.button}
        label={i18n.t("Button.allOffer")}
        dark
      />
    </section>
  );
};
export default View;
